app.factory('getTitleHeight', function() {
	return function(){
		var headerHeight = $('#header').outerHeight();
		var titleHeight = $('.page__title').outerHeight();
		console.log(titleHeight);
		$('main').animate({
			'padding-top': headerHeight + titleHeight + 20,
		},200);
	};
});